<template>
  <div>
    <v-sheet class="rounded-xl rounded-t-0 mx-auto" max-width="100%">
      <v-img :src="require('@/assets/news_report.png')"></v-img>
    </v-sheet>
    <v-overlay :value="dataReady">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container>
      <v-dialog v-model="dialogNews" fullscreen>
        <v-card class="ma-4" color="#FFFFFF">
          <v-container>
            <v-row justify="space-around">
              <v-col cols="12" md="4">
                <!-- <v-sheet color="#FFFFFF" rounded="xl" width="380"> -->
                <br />
                <center>
                  <h5 class="purple--text pa-2">
                    {{ data.newsConfigTopic }}
                  </h5>
                </center>
                <v-col>
                  <v-img :src="data.newsConfigFile"> </v-img>
                </v-col>
                <v-card-text class="text--primary">
                  <!-- <h5 class="purple--text pa-2" v-html="data.newsConfigTopic"></h5> -->
                  <h5 class="indigo--text" v-html="data.newsConfigHead"></h5>
                </v-card-text>

                <v-col>
                  <v-img v-if="data.newsConfigFileImg" :src="data.newsConfigFileImg"> </v-img>
                </v-col>

                <v-card-text class="text--primary">
                  <h6 v-html="data.newConfigDetail"></h6>
                </v-card-text>

                <v-col class="text-center">
                  <v-btn
                    color="#C62929"
                    dark
                    @click="(dialogNews = false), getData()"
                  >
                    กลับหน้าเมนูข่าว
                  </v-btn>
                </v-col>
                <!-- </v-sheet> -->
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>

      <v-row no-gutters>
        <v-icon color="cyan" @click="$router.push('/Liff/News')"
          >mdi-home</v-icon
        >
        <v-col class="pt-2 pb-2"
          ><h5 class="font-weight-bold font-size: 15">
            / กิจกรรม
          </h5></v-col
        >
      </v-row>

      <v-card
        class="pa-2 mb-7"
        v-for="(item, index) in dataItemNew"
        :key="index.newsConfigId"
        elevation="10"
      >
        <v-row>
          <v-col cols="3" class="pt-5 pl-5">
            <v-avatar color="grey" size="100" rounded>
              <v-img :src="item.newsConfigFile"></v-img>
            </v-avatar>
          </v-col>
          <v-col cols="7" class="pt-2 pl-7 text-right">
            <v-card-text class="text-left">
              <h5
                class="indigo--text d-inline-block text-truncate"
                style="max-width: 200px"
                v-html="item.newsConfigTopic"
              ></h5>
              <h6
                class="d-inline-block text-truncate"
                style="max-width: 200px"
                v-html="item.newsConfigHead"
              ></h6>
              <v-row>
                <caption color="grey" class="pl-3 pt-0 pb-0 pr-0 ma-0">
                  {{
                    item.newConfigStarttime
                  }}
                </caption>
                <v-btn @click="sentData(item)" color="info" text>
                  อ่านข่าวเพิ่มเติม
                </v-btn>
              </v-row>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
      <!-- <v-card
        class="pa-2 mb-7"
        v-for="(item, index) in dataItemCheck"
        :key="index.newsConfigId"
        elevation="10"
      >
        <v-row>
          <v-col cols="3" class="pt-5 pl-5">
            <v-avatar color="grey" size="100" rounded>
              <v-img :src="item.newsConfigFile"></v-img>
            </v-avatar>
          </v-col>
          <v-col cols="7" class="pt-2 pl-7 text-right">
            <v-card-text class="text-right">
              <h5
                class="indigo--text d-inline-block text-truncate"
                style="max-width: 200px"
                v-html="item.newsConfigTopic"
              ></h5>
              <h6
                class="d-inline-block text-truncate"
                style="max-width: 200px"
                v-html="item.newsConfigHead"
              ></h6>
              <v-row>
                <caption color="grey" class="pl-3 pt-0 pb-0 pr-0 ma-0">
                  {{
                    item.newConfigStarttime
                  }}
                </caption>
                <v-btn @click="readData(item)" color="info" text>
                  อ่านข่าวเพิ่มเติม
                </v-btn>
              </v-row>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card> -->
    </v-container>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'News',
  beforeCreate () {
    // console.log(this.$liff_news)
    // this.$liff.init({ liffId: this.$liff_news }, function (data) {})
  },
  created () {},
  data () {
    return {
      profile: [],
      dataItemNew: [],
      dataItemKnowledge: [],
      dataItemCheck: [],
      data: [],
      formUpdate: [],
      year: '',
      month: '',
      day: '',
      dataReady: true,
      dialogNews: false,
      model: 0,
      colors: ['primary', 'secondary', 'yellow darken-2', 'red', 'orange']
    }
  },
  async mounted () {
    this.profile = JSON.parse(localStorage.getItem('profileNews'))
    await this.getData()
  },
  methods: {
    async getData () {
      this.dataReady = true
      this.dataItemNew = await this.getDataNewConfig()
      this.dataItemCheck = await this.getDataNewsCheck()
      await this.checkViewNewsById()
      this.dataReady = false
    },
    async checkViewNewsById () {
      if (this.$route.query.action === 'read') {
        let data = await this.getDataNewsGetById(this.$route.query.id)
        if (data) {
          await this.sentData(data)
        } else {
          this.$router.replace({'id': null, 'action': 'all'})
          this.dataReady = false
        }
      }
    },
    async getDataNewsGetById (newsConfigId) {
      return axios.get(
        this.DNS_IP +
          '/news_check/getID?empCode=' +
          this.profile.empCode +
          '&newsConfigId=' +
          newsConfigId
      )
    },
    async getDataNewConfig () {
      try {
        var res = await axios.get(
          this.DNS_IP + '/news_config/getData?newsConfigType=กิจกรรม'
        )
        return res.data.length > 0 ? res.data : null
      } catch (error) {
        console.error('error news', error)
      }
    },
    async getDataNewsCheck () {
      try {
        var res = await axios.get(
          this.DNS_IP + '/news_check/get?newsConfigType=กิจกรรม&empCode=' + this.profile.empCode
        )
        return res.data.length > 0 ? res.data : null
      } catch (error) {
        console.error('error news', error)
      }
    },
    async readData (dt) {
      this.data = dt
      this.dialogNews = true
    },
    async sentData (dt) {
      console.log('data', dt)
      console.log('profile', this.profile)
      try {
        this.dialogNews = true
        this.dataReady = true
        this.data = dt
        console.log('this.data', dt.newsConfigId)
        console.log('empCode', this.profile.empCode)
        let dataCheckDuplicate = this.getDataNewsGetById(dt.newsConfigId)
        console.log('dataCheckDuplicate', dataCheckDuplicate)
        let check = await dataCheckDuplicate
          .then((res) => {
            return 'success'
          })
          .catch(() => {
            return 'error'
          })
        console.log('dataCheckDuplicate', dataCheckDuplicate)
        console.log('check', check)
        if (check === 'error') {
          let ds = {
            newsConfigId: dt.newsConfigId,
            empCode: this.profile.empCode,
            CREATE_USER: this.profile.userName,
            LAST_USER: this.profile.userName
          }
          await axios.post(this.DNS_IP + '/news_check/add', ds)
          this.dataReady = false
        }
      } catch (error) {
        console.error('error send data news', error)
      }
    }
    // async getDataNewsGetById (newsConfigId) {
    //   return axios.get(
    //     this.DNS_IP +
    //       '/news_check/getID?empCode=' +
    //       this.profile.empCode +
    //       '&newsConfigId=' +
    //       newsConfigId
    //   )
    // }
  }

}

</script>
<style scoped>
.table-header {
  background-color: black;
}
.a >>> .ql-align-center {
  text-align: center;
}
.mdc-typography-styles-headline6 {
  font-family: unquote("Kanit");
  font-size: 30;
}
.mdc-typography-styles-headline5 {
  font-family: unquote("Sarabun");
  font-size: 15;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/NewsToActivity.vue